module.exports = __webpack_public_path__ + "static/media/google-podcasts-button.68554e60.jpg";